<div [class]="wrapperClass + ' input-wrapper'" [formGroup]="form">
	<select *ngIf="countries.length > 0" [(ngModel)]="model" (select)="updateModel($event)" [name]="name" [id]="name" [required]="required" [formControlName]="name" (change)="updateModel($event)">
		<option *ngFor="let country of countries" [value]="country.code">{{ country.country }}</option>
	</select>
	<label [attr.for]="name" [class.error]="elementValid() == false" [innerHtml]="elementValid()? label : error? error : label"></label>
</div>
